import React from "react";
import { Grid, Skeleton, EmptyState } from "@astryxdesign/core";

export interface LoadableCardGridEmptyState {
  icon?: React.ReactNode;
  headline: string;
  subtext?: string;
  action?: React.ReactNode;
}

export interface LoadableCardGridProps {
  loading: boolean;
  emptyState?: LoadableCardGridEmptyState;
  skeletonCount?: number;
  children: React.ReactNode;
}

const COLUMNS = { minWidth: 280, max: 4 };

const LoadableCardGrid = ({
  loading,
  emptyState,
  skeletonCount = 8,
  children,
}: LoadableCardGridProps): React.ReactElement => {
  if (loading) {
    return (
      <Grid columns={COLUMNS} gap={4} align="stretch">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <Skeleton key={i} width="100%" height={168} />
        ))}
      </Grid>
    );
  }

  // Done loading with nothing to show — render the design-system empty state.
  if (emptyState && React.Children.count(children) === 0) {
    return (
      <EmptyState
        title={emptyState.headline}
        description={emptyState.subtext}
        icon={emptyState.icon}
        actions={emptyState.action}
      />
    );
  }

  return (
    <Grid columns={COLUMNS} gap={4}>
      {children}
    </Grid>
  );
};

export default LoadableCardGrid;
